import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import { RestBids } from '../services/rest_bids';

interface IFiltersState {
    dataFilters: []
}

const initialState: IFiltersState = {
    dataFilters: []
};
export const filtersBits = createAsyncThunk(
    'filtersBits',
    async (payload: {}) => {
        return await RestBids.filtersBits(payload)
    }
)
export const getFiltersBits: any = createAsyncThunk(
  'getFiltersBits',
  async (payload: {}) => {
      return await RestBids.getFiltersBits(payload)
  }
)
const filtersSlice = createSlice({
    name: 'filtersSlice',
    initialState,
    reducers: {
        clearFiltersFetch(state) {
            state.dataFilters = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(filtersBits.fulfilled, (state, action) => {
            state.dataFilters = [];
            state.dataFilters = action.payload.rows
        })
    },
});
export default filtersSlice.reducer;
export const {clearFiltersFetch} = filtersSlice.actions
